module.exports = __webpack_public_path__ + "img/vipgroup_access_icon.9735f941.png";